import { storePersistentData } from './persistent-data/persistent-data';

const AUTO_TEST_USERS = [
  'browser05@norlys.testinator.com',
  'browser2@norlys.testinator.com',
  'browser.auto.stofa@gmail.com'
];

export const checkForAutoTest = (email?: string) => {
  const isAutoTestUser = email ? AUTO_TEST_USERS.includes(email) : false;

  storePersistentData('isAutoTestUser', isAutoTestUser);
};
